import { useTranslation } from 'react-i18next'

import { danUnaprijed } from '../lib/termin'
import { PoljeDatuma } from './datum/PoljeDatuma'
import { PoljeVremena } from './datum/PoljeVremena'

/**
 * DATUM I VRIJEME SE BIRAJU, NE TIPKAJU (dotjerivanje-4 §2).
 *
 * Isti par polja traže DVA ekrana pružatelja — red upita na površini zaposlenika
 * i javna stranica iz e-pošte — i to za istu radnju: protuprijedlog. Dotad su ga
 * oba crtala sama, pa se razlika između njih vidjela tek kad bi netko na jednom
 * dodao granicu koju drugi nema. Ovdje stoje jednom, sa svime što uz njih ide:
 *
 * · **Vlastiti picker** (D15-A §4): `d.M.yyyy` i 24-satni sat, bez obzira na
 *   jezik preglednika. Nativno polje je ovdje bilo najgore moguće mjesto —
 *   protuprijedlog termina je JEDINA stvar koju taj ekran radi.
 * · **Krupna meta** (§17): termin je odluka, a ne polje obrasca.
 * · **`min` je DANAS**: termin u prošlosti poslužitelj odbija (`past_termin`), pa
 *   ga kalendar ne nudi. Brana ostaje na poslužitelju — ovo je pristojnost, ne
 *   provjera.
 *
 * Vrijednost drži POZIVATELJ, jer je on zna napuniti: obrazac se otvara na
 * gostovom terminu (`poljaIzTrenutka`), a ne prazan — protuprijedlog je pomak
 * onoga što je gost tražio.
 */
export function IzborTermina({
  datum,
  vrijeme,
  naDatum,
  naVrijeme,
}: {
  datum: string
  vrijeme: string
  naDatum: (vrijednost: string) => void
  naVrijeme: (vrijednost: string) => void
}) {
  const { t } = useTranslation()

  return (
    <>
      <PoljeDatuma
        ton="noir"
        krupno
        min={danUnaprijed(0)}
        label={t('gost.upitPonude.datum')}
        value={datum}
        onValue={naDatum}
      />

      <PoljeVremena
        ton="noir"
        krupno
        label={t('gost.upitPonude.vrijeme')}
        value={vrijeme}
        onValue={naVrijeme}
      />
    </>
  )
}
